import {DefaultTheme, NavigationContainer} from '@react-navigation/native';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import React from 'react';
import {useIntl} from 'react-intl';

import PromotionBanner from '@/components/PromotionBanner';
import EmbedArtist from '@/screens/Embed/Artist/Artist';
import EmbedCollection from '@/screens/Embed/Collection/Collection';
import EmbedPlatform from '@/screens/Embed/Platform/Platform';
import EmbedPlayer from '@/screens/Embed/Player/Player';
import EmbedPlaylist from '@/screens/Embed/Playlist/Playlist';
import {useTheme} from '@/theme';
import {EmbedStackParams, Routes} from '@/types/routes';
import {checkIframe} from '@/utils/platform';

import {linkingConfig} from './embedRoutesConfig';

const Stack = createNativeStackNavigator<EmbedStackParams>();

const EmbedNavigation = () => {
  const theme = useTheme();
  const {formatMessage} = useIntl();

  const navigationTheme = {
    ...DefaultTheme,
    colors: {
      ...DefaultTheme.colors,
      background: theme.colors.backgroundLight,
    },
  };

  return (
    <>
      {!checkIframe() && <PromotionBanner />}
      <NavigationContainer
        linking={linkingConfig}
        theme={navigationTheme}
        documentTitle={{formatter: () => formatMessage({id: 'appName'})}}>
        <Stack.Navigator
          screenOptions={{
            headerShown: false,
            presentation: 'modal',
            gestureEnabled: false,
          }}>
          <Stack.Screen name={Routes.EmbedPlayer} component={EmbedPlayer} />
          <Stack.Screen name={Routes.EmbedArtist} component={EmbedArtist} />
          <Stack.Screen name={Routes.EmbedPlaylist} component={EmbedPlaylist} />
          <Stack.Screen name={Routes.EmbedPlatform} component={EmbedPlatform} />
          <Stack.Screen
            name={Routes.EmbedCollection}
            component={EmbedCollection}
          />
        </Stack.Navigator>
      </NavigationContainer>
    </>
  );
};

export default EmbedNavigation;
